<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <h4 class="m-0">Outbound Transaction 1</h4>
          </div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-right">
              <li class="breadcrumb-item">
                <router-link to="/dashboard">Dashboard</router-link>
              </li>
              <li class="breadcrumb-item active">
                <router-link to="/outbound-transcation"
                  >Outbound Transaction</router-link
                >
              </li>
              <li class="breadcrumb-item active">
                <span>Transaction 1</span>
              </li>
            </ol>
          </div>
        </div>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-12">
            <div class="card card-plb">
              <div class="card-header ui-sortable-handle">
                <h5 class="card-title card_title_margin">
                  <i class="nav-icon fa-solid fa-money-bill-transfer"></i>
                  Outbound Transaction 1
                </h5>
                <div class="card-tools">
                  <button
                    type="button"
                    data-card-widget="collapse"
                    class="btn btn-tool"
                  >
                    <i class="fas fa-minus"></i>
                  </button>
                </div>
              </div>
              <!-- BEGIN: Card Body -->
              <div class="card-body">
                <!-- BEGIN: Cari Data -->
                <div class="row justify-content-center">
                  <div class="col-md-8">
                    <form @submit.prevent class="form-horizontal">
                      <div class="form-group row mt-4">
                        <label class="col-sm-3 col-form-label"
                          >Tanggal Outbound</label
                        >
                        <div class="col-sm-4">
                          <datepicker
                            v-if="$gate.isAdminOrPlanner()"
                            input-class="form-control"
                            placeholder="Dari Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_start_date"
                            autofocus
                          />
                          <datepicker
                            v-else-if="$gate.isUser()"
                            :disabledDates="disabled_dates"
                            :disabled="true"
                            input-class="form-control"
                            placeholder="Dari Tanggal"
                            format="dd/MM/yyyy"
                            v-model="default_start_date"
                            autofocus
                          />
                        </div>
                        <div class="col-sm-4">
                          <datepicker
                            v-if="$gate.isAdminOrPlanner()"
                            input-class="form-control"
                            placeholder="Sampai Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_end_date"
                            autofocus
                          />
                          <datepicker
                            v-else-if="$gate.isUser()"
                            :disabledDates="disabled_dates"
                            input-class="form-control"
                            placeholder="Sampai Tanggal"
                            format="dd/MM/yyyy"
                            v-model="filter_end_date"
                          />
                        </div>
                      </div>

                      <div
                        class="form-group row"
                        id="dokumenList"
                        v-if="$gate.isAdminOrPlanner()"
                      >
                        <label class="col-sm-3 col-form-label"
                          >Jenis Dokumen</label
                        >
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC27"
                              value="BC27"
                              v-model="filter_jenis_bc"
                            />
                            27
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC28"
                              value="BC28"
                              v-model="filter_jenis_bc"
                            />
                            28
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC30"
                              value="BC30"
                              v-model="filter_jenis_bc"
                            />
                            30
                          </label>
                        </div>
                        <div class="col-sm-2">
                          <label class="control-label" style="margin-top: 5px">
                            <input
                              type="checkbox"
                              id="BC41"
                              value="BC41"
                              v-model="filter_jenis_bc"
                            />
                            41
                          </label>
                        </div>
                      </div>

                      <div class="form-group row justify-content-center">
                        <div class="col-sm-6">
                          <button class="btn btn-primary" @click="filterButton">
                            <i class="fa-solid fa-magnifying-glass"></i>
                            Filter
                          </button>
                          <button class="btn btn-secondary" @click="clearForm">
                            <i class="fa-solid fa-rotate"></i> Reset
                          </button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
                <!-- END: Cari Data -->
                <hr />

                <!-- BEGIN: Tampil Data -->
                <div class="form-group mt-4">
                  <div class="vgt-wrap polar-bear">
                    <div class="vgt-inner-wrap">
                      <!-- BEGIN: Global Search -->
                      <div class="vgt-global-search vgt-clearfix">
                        <div class="vgt-global-search__input vgt-pull-left">
                          <label>
                            <span aria-hidden="true" class="input__icon">
                              <div class="magnifying-glass"></div>
                            </span>
                            <span class="sr-only"> Search </span>
                          </label>
                          <input
                            type="text"
                            placeholder="Search Data"
                            class="vgt-input vgt-pull-left"
                            v-model="search"
                            @change="list()"
                          />
                        </div>
                        <!-- BEGIN: Right Button -->
                        <div class="vgt-global-search__actions vgt-pull-right">
                          <div>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              @click="exportCsv"
                            >
                              <i class="fa-solid fa-file-csv"></i>
                              CSV
                            </button>
                            <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                              @click="exportExcel"
                            >
                              <i class="fa-solid fa-file-excel"></i>
                              Excel
                            </button>
                            <!-- <button
                              class="btn btn-secondary ms-auto rounded-1"
                              style="margin-right: 10px"
                            >
                              <i class="fa-solid fa-file-pdf"></i>
                              PDF
                            </button> -->
                          </div>
                        </div>

                        <!-- END: Right Button -->
                      </div>
                      <!-- END: Global Search -->

                      <!-- BEGIN: Table -->
                      <div class="vgt-responsive">
                        <table
                          id="vgt-table"
                          class="vgt-table bordered polar-bear"
                        >
                          <!-- BEGIN: Thead -->
                          <thead>
                            <!-- BEGIN: TR Description -->
                            <tr>
                              <!-- BEGIN: Number -->
                              <th class="text-center">
                                <span class="table_header">No.</span>
                              </th>
                              <!-- END: Number  -->

                              <!-- BEGIN: Kode Barang -->
                              <th
                                v-if="order == 'KODE_BARANG' && by == 'asc'"
                                @click="sort('KODE_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'KODE_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('KODE_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Kode Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Kode Barang -->

                              <!-- BEGIN: Nama Barang -->
                              <th
                                v-if="order == 'NAMA_BARANG' && by == 'asc'"
                                @click="sort('NAMA_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'NAMA_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Barang -->

                              <!-- BEGIN: Satuan -->
                              <th
                                v-if="order == 'SATUAN' && by == 'asc'"
                                @click="sort('SATUAN', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'SATUAN' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('SATUAN', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Satuan</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Satuan -->

                              <!-- BEGIN: Jumlah Barang -->
                              <th
                                v-if="order == 'JUMLAH_BARANG' && by == 'asc'"
                                @click="sort('JUMLAH_BARANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'JUMLAH_BARANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('JUMLAH_BARANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Jumlah Barang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Jumlah Barang -->

                              <!-- BEGIN: Matdoc Item -->
                              <th
                                v-if="order == 'MATDOC_ITEM' && by == 'asc'"
                                @click="sort('MATDOC_ITEM', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Matdoc Item</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="order == 'MATDOC_ITEM' && by == 'desc'"
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Matdoc Item</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('MATDOC_ITEM', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Matdoc Item</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Type BC Header -->

                              <!-- BEGIN: Tanggal Pengeluaran -->
                              <th
                                v-if="
                                  order == 'TANGGAL_PENGELUARAN' && by == 'asc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'TANGGAL_PENGELUARAN' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('TANGGAL_PENGELUARAN', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Tanggal Pengeluaran</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Tanggal Pengeluaran -->

                              <!-- BEGIN: Nama Gudang -->
                              <th
                                v-if="order == 'NAMA_GUDANG' && by == 'asc'"
                                @click="sort('NAMA_GUDANG', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Gudang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'NAMA_GUDANG' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Gudang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_GUDANG', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Gudang</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Gudang -->

                              <!-- BEGIN: Nama Airlines -->
                              <th
                                v-if="order == 'NAMA_AIRLINES' && by == 'asc'"
                                @click="sort('NAMA_AIRLINES', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header">Nama Airlines</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'NAMA_AIRLINES' && by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header">Nama Airlines</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('NAMA_AIRLINES', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header">Nama Airlines</span>
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Nama Airlines -->

                              <!-- BEGIN: Registrasi PK/Non PK -->
                              <th
                                v-if="
                                  order == 'AIRCRAFT_REGISTRATION' &&
                                  by == 'asc'
                                "
                                @click="sort('AIRCRAFT_REGISTRATION', 'desc')"
                                class="text-center sortable sorting sorting-asc"
                              >
                                <span class="table_header"
                                  >Registrasi PK/Non PK</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else-if="
                                  order == 'AIRCRAFT_REGISTRATION' &&
                                  by == 'desc'
                                "
                                @click="sort('TANGGAL_PENGELUARAN', 'desc')"
                                class="text-center sortable sorting sorting-desc"
                              >
                                <span class="table_header"
                                  >Registrasi PK/Non PK</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <th
                                v-else
                                @click="sort('AIRCRAFT_REGISTRATION', 'asc')"
                                class="text-center sortable"
                              >
                                <span class="table_header"
                                  >Registrasi PK/Non PK</span
                                >
                                <button>
                                  <span class="sr-only"></span>
                                </button>
                              </th>
                              <!-- END: Registrasi PK/Non PK -->
                            </tr>
                            <!-- END: TR Description-->

                            <!-- BEGIN: TR Filter -->
                            <tr>
                              <!-- BEGIN: Filter Number -->
                              <th class="filter-th"></th>
                              <!-- END: Filter Number -->

                              <!-- BEGIN: Filter Kode Barang -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    v-model="search_kode_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Kode Barang -->

                              <!-- BEGIN: Filter Nama Barang -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    v-model="search_nama_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Nama Barang -->

                              <!-- BEGIN: Filter Satuan -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    v-model="search_satuan"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Satuan -->

                              <!-- BEGIN: Filter Jumlah Barang -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    v-model="search_jumlah_barang"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Jumlah Barang -->

                              <!-- BEGIN: Filter Matdoc Item -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    v-model="search_matdoc_item"
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Matdoc Item -->

                              <!-- BEGIN: Filter Tanggal Pengeluaran -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="date"
                                    v-model="search_tanggal_pengeluaran"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Tanggal Pengeluaran -->

                              <!-- BEGIN: Filter Nama Gudang -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    v-model="search_nama_gudang"
                                    placeholder="Search ..."
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Nama Gudang -->

                              <!-- BEGIN: Filter Nama Airlines -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    v-model="search_nama_airlines"
                                    placeholder="Search ..."
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Nama Airlines -->

                              <!-- BEGIN: Filter Register Aircraft -->
                              <th class="filter-th">
                                <div>
                                  <input
                                    type="text"
                                    class="vgt-input text-center"
                                    placeholder="Search ..."
                                    v-model="search_aircraft_registration"
                                    @change="list()"
                                  />
                                </div>
                              </th>
                              <!-- END: Filter Register Aircraft -->
                            </tr>
                            <!-- END: TR Filter -->
                          </thead>
                          <!-- END: Thead -->

                          <!-- BEGIN: Tbody -->
                          <tbody>
                            <tr
                              v-for="(
                                outbound, outbound_index
                              ) in outbounds.data"
                              :key="outbound_index"
                            >
                              <!-- BEGIN: Number -->
                              <td class="text-center table-content">
                                {{ outbounds.from + outbound_index }}
                              </td>

                              <!-- END: Number -->
                              <!-- BEGIN: Kode Barang -->
                              <td
                                v-if="outbound.KODE_BARANG === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.KODE_BARANG }}
                              </td>
                              <!-- END: Kode Barang -->
                              <!-- BEGIN: Nama Barang -->
                              <td
                                v-if="outbound.NAMA_BARANG === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.NAMA_BARANG }}
                              </td>
                              <!-- END: Nama Barang -->

                              <!-- BEGIN: Kode Satuan -->
                              <td
                                v-if="outbound.SATUAN === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.SATUAN }}
                              </td>
                              <!-- END: Kode Satuan -->
                              <!-- BEGIN: Jumlah Barang -->
                              <td
                                v-if="outbound.JUMLAH_BARANG === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.JUMLAH_BARANG }}
                              </td>
                              <!-- END: Jumlah Barang -->
                              <!-- BEGIN: Matdoc Item -->
                              <td
                                er
                                v-if="outbound.MATDOC_ITEM === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.MATDOC_ITEM }}
                              </td>
                              <!-- END: Matdoc Item -->

                              <!-- BEGIN: Tanggal Pengeluaran -->
                              <td class="table_content text-center">
                                {{ outbound.TANGGAL_PENGELUARAN | myDateTime }}
                              </td>
                              <!-- END: Tanggal Pengeluaran -->

                              <!-- BEGIN: Nama Gudang -->
                              <td
                                v-if="outbound.NAMA_GUDANG === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.NAMA_GUDANG }}
                              </td>
                              <!-- END: Nama Gudang -->

                              <!-- BEGIN: Nama Airlines -->
                              <td
                                v-if="outbound.NAMA_AIRLINES === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.NAMA_AIRLINES }}
                              </td>
                              <!-- END: Nama Airlines -->

                              <!-- BEGIN: Register Aircraft -->
                              <td
                                v-if="outbound.AIRCRAFT_REGISTRATION === null"
                                class="text-center table_content"
                              >
                                -
                              </td>
                              <td class="text-center table_content" v-else>
                                {{ outbound.AIRCRAFT_REGISTRATION }}
                              </td>
                              <!-- END: Register Aircraft -->
                            </tr>
                            <tr v-if="outbounds.data.length < 1">
                              <td colspan="15">
                                <div class="vgt-center-align vgt-text-disabled">
                                  Data not found
                                </div>
                              </td>
                            </tr>
                          </tbody>
                          <!-- END: Tbody -->
                        </table>
                      </div>
                      <!-- END: Table -->
                      <!-- BEGIN: Paginate -->
                      <div class="vgt-wrap__footer vgt-clearfix">
                        <div class="footer__row-count vgt-pull-left">
                          <label
                            class="footer__row-count__label row_per_page_label"
                          >
                            Rows per page:
                          </label>
                          <select
                            class="footer__row-count__select row_per_page_option"
                            v-model="paginate"
                            @change="list()"
                          >
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                          </select>
                        </div>
                        <div class="footer__navigation vgt-pull-right">
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !outbounds.prev_page_url,
                            }"
                            @click="
                              outbounds.prev_page_url &&
                                list(outbounds.prev_page_url)
                            "
                            style="margin-right: 0px"
                          >
                            <span
                              aria-hidden="true"
                              class="chevron left"
                            ></span>
                            <span class="paginate_text">Prev</span>
                          </button>
                          <div
                            class="footer__navigation__page-info"
                            style="color: #99a0b2"
                          >
                            <label
                              class="page-info__label"
                              style="margin-bottom: -5px"
                            >
                              <span class="paginate_text">page</span>
                              <input
                                type="text"
                                class="footer__navigation__page-info__current-entry vgt-input"
                                v-model="current_page"
                                @keypress="directPage"
                                style="width: 60px"
                              />
                              <span class="paginate_text">
                                of
                                {{ outbounds.last_page }}
                              </span>
                            </label>
                          </div>
                          <button
                            type="button"
                            class="footer__navigation__page-btn"
                            :class="{
                              disabled: !outbounds.next_page_url,
                            }"
                            @click="
                              outbounds.next_page_url &&
                                list(outbounds.next_page_url)
                            "
                          >
                            <span style="font-weight: 500">Next</span>
                            <span
                              aria-hidden="true"
                              class="chevron right"
                            ></span>
                          </button>
                        </div>
                      </div>
                      <!-- END: Paginate -->
                    </div>
                  </div>
                </div>
                <!-- END: Tampil Data -->
              </div>
              <!-- END: Card Body -->
            </div>
            <!-- END: Card -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import debounce from "lodash/debounce";
import moment from "moment";
import Swal from "sweetalert2";

moment.locale("id");

export default {
  data() {
    return {
      outbounds: {
        data: [],
        links: [],
      },
      // ! Search Data
      search: null, // * Search G
      search_kode_barang: null,
      search_nama_barang: null,
      search_satuan: null,
      search_jumlah_barang: null,
      search_jenis_bc: null,
      search_matdoc_item: null,
      search_tanggal_pengeluaran: null,
      search_nama_airlines: null,
      search_nama_gudang: null,
      search_aircraft_registration: null,

      // ! Filter Data
      disabled_dates: {to: new Date(2023, 2, 16)},
      default_start_date: new Date(2023, 2, 16), 

      filter_start_date: null,
      filter_end_date: null,
      filter_jenis_bc: [],

      // ! Order By
      order: "TANGGAL_PENGELUARAN",
      by: "desc",
      paginate: "10",
      current_page: null,
    };
  },

  methods: {
    list(paginate) {
      this.showLoading();
      paginate = paginate || `/api/outbound-transaction-1`;
      axios
        .get(paginate, {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_matdoc_item: this.search_matdoc_item,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_airlines: this.search_nama_airlines,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
        })
        .then((response) => {
          this.outbounds = response.data;
          this.current_page = this.outbounds.current_page;
          Swal.close();
          this.showSuccessRequest();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorRequest();
          console.log(error);
        });
    },
    exportExcel() {
      this.showLoading();
      axios
        .get("/api/outbound-transaction-1-excel", {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_matdoc_item: this.search_matdoc_item,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_airlines: this.search_nama_airlines,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "outbound-transaction-one.xlsx");
          document.body.appendChild(link);
          link.click();
          Swal.close();
          console.log("RESPONSE", response);
          this.showSuccessExport();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorExport();
          console.log(error);
        });
    },
    exportCsv() {
      this.showLoading();
      axios
        .get("/api/outbound-transaction-1-csv", {
          params: {
            search: this.search,
            search_kode_barang: this.search_kode_barang,
            search_nama_barang: this.search_nama_barang,
            search_satuan: this.search_satuan,
            search_jumlah_barang: this.search_jumlah_barang,
            search_jenis_bc: this.search_jenis_bc,
            search_matdoc_item: this.search_matdoc_item,
            search_tanggal_pengeluaran: this.search_tanggal_pengeluaran,
            search_nama_airlines: this.search_nama_airlines,
            search_nama_gudang: this.search_nama_gudang,
            search_aircraft_registration: this.search_aircraft_registration,
            filter_start_date: this.filter_start_date,
            filter_end_date: this.filter_end_date,
            filter_jenis_bc: this.filter_jenis_bc,
            order: this.order,
            by: this.by,
            paginate: this.paginate,
          },
          responseType: "blob",
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "outbound-transaction-one.csv");
          document.body.appendChild(link);
          link.click();
          Swal.close();
          this.showSuccessExport();
        })
        .catch((error) => {
          Swal.close();
          this.showErrorExport();
          console.log(error);
        });
    },
    filterButton() {
      this.list();
    },
    showLoading() {
      Swal.fire({
        didOpen: () => {
          Swal.showLoading();
        },
        background: "transparent",
        allowOutsideClick: false,
      });
    },
    showSuccessRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorRequest() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Retrieve Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showSuccessExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Successfully Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    showErrorExport() {
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to Export Data",
        showConfirmButton: false,
        timer: 1500,
      });
    },
    clearForm() {
      this.outbounds = {
        data: [],
        links: [],
      };
      this.filter_start_date = null;
      this.filter_end_date = null;
      this.filter_jenis_bc = [];
      this.search = null;
      this.search_kode_barang = null;
      this.search_nama_barang = null;
      this.search_satuan = null;
      this.search_jumlah_barang = null;
      this.search_jenis_bc = null;
      this.search_matdoc_item = null;
      this.search_tanggal_pengeluaran = null;
      this.search_nama_gudang = null;
      this.search_nama_airlines = null;
      this.search_aircraft_registration = null;
    },
    directPage: debounce(function () {
      if (this.current_page < 1) {
        this.current_page = 1;
      } else if (this.current_page > this.outbounds.last_page) {
        this.current_page = this.outbounds.last_page;
      }
      let url = new URL(this.outbounds.first_page_url);
      let search_params = url.searchParams;
      search_params.set("page", this.current_page);
      url.search = search_params.toString();
      let new_url = url.toString();
      this.list(new_url);
    }, 500),
    sort(order, by) {
      this.order = order;
      this.by = by;
      this.list();
    },
  },
};
</script>
<style scoped>
.vgt-global-search__input .input__icon .magnifying-glass {
  margin-top: -3px;
}
</style>
